export const TOPP_SEASON = '2025';
export const TOPP_CURRENT_GW = 8;
export const TOPP_TOTAL_GW = 22;
export const TOPP_STANDINGS = [
    { pos:1, name:'Brann',       short:'BRA', color:'#E3000F', p:8, w:6, d:1, l:1, gf:18, ga:7,  form:['W','W','D','W','W'], zone:'cl',  pts:19 },
    { pos:2, name:'Rosenborg',   short:'RBK', color:'#000000', p:8, w:5, d:2, l:1, gf:15, ga:8,  form:['W','D','W','W','D'], zone:'cl',  pts:17 },
    { pos:3, name:'Valernga',    short:'VIF', color:'#0047AB', p:8, w:5, d:1, l:2, gf:14, ga:9,  form:['W','W','L','W','W'], zone:'cl',  pts:16 },
    { pos:4, name:'LSK Kvinner', short:'LSK', color:'#FF6600', p:8, w:4, d:2, l:2, gf:13, ga:10, form:['D','W','W','L','W'], zone:'',    pts:14 },
    { pos:5, name:'Lyn Fotball', short:'LYN', color:'#FFDD00', p:8, w:3, d:3, l:2, gf:11, ga:9,  form:['W','D','W','D','L'], zone:'',    pts:12 },
    { pos:6, name:'Stabak',      short:'STB', color:'#005BAA', p:8, w:3, d:2, l:3, gf:10, ga:11, form:['L','W','D','W','L'], zone:'',    pts:11 },
    { pos:7, name:'Avaldsnes',   short:'AVA', color:'#800000', p:8, w:2, d:3, l:3, gf:9,  ga:12, form:['D','L','W','D','L'], zone:'',    pts:9  },
    { pos:8, name:'Sandviken',   short:'SAN', color:'#003366', p:8, w:2, d:2, l:4, gf:8,  ga:13, form:['L','D','L','W','D'], zone:'rel', pts:8  },
];
export const TOPP_SCORERS = [
    { name:'Karina Saevik',    initials:'KS', club:'Rosenborg',   goals:7 },
    { name:'Guro Reiten',      initials:'GR', club:'Brann',       goals:6 },
    { name:'Ada Hegerberg',    initials:'AH', club:'LSK Kvinner', goals:5 },
    { name:'Caroline Graham',  initials:'CG', club:'Valernga',    goals:5 },
    { name:'Frida Maanum',     initials:'FM', club:'Brann',       goals:4 },
];
export const TOPP_FIXTURES = [
    { date:'2025-04-05', home:'Brann',     away:'Rosenborg',   homeGoals:2, awayGoals:1, status:'FT', homeColor:'#E3000F', awayColor:'#000000' },
    { date:'2025-04-12', home:'Valernga',  away:'LSK Kvinner', homeGoals:1, awayGoals:1, status:'FT', homeColor:'#0047AB', awayColor:'#FF6600' },
    { date:'2025-04-19', home:'Rosenborg', away:'Stabak',      homeGoals:3, awayGoals:0, status:'FT', homeColor:'#000000', awayColor:'#005BAA' },
    { date:'2025-04-26', home:'Brann',     away:'Valernga',    homeGoals:0, awayGoals:0, status:'NS', homeColor:'#E3000F', awayColor:'#0047AB' },
    { date:'2025-05-03', home:'LSK Kvinner',away:'Rosenborg',  homeGoals:0, awayGoals:0, status:'NS', homeColor:'#FF6600', awayColor:'#000000' },
];
export function toppPts(t) { return t.w * 3 + t.d; }
export function toppGD(t)  { return t.gf - t.ga; }

export async function fetchLiveToppserienData() {
    const PROXY_URL = 'https://toppserien-proxy.footballgirl.workers.dev';
    try {
        const res = await fetch(PROXY_URL, { signal: AbortSignal.timeout(5000) });
        if (!res.ok) throw new Error('HTTP ' + res.status);
        const data = await res.json();
        if (!data.standings || !data.standings.length) throw new Error('empty');
        return {
            standings: data.standings,
            scorers:   TOPP_SCORERS,
            fixtures:  TOPP_FIXTURES,
        };
    } catch (e) {
        console.warn('[fetchLiveToppserienData] proxy failed, using fallback:', e.message);
        return null;
    }
}
